import { Link } from 'react-router-dom'
import { useCart } from '../context/CartContext'
import './Cart.css'

export default function Cart() {
    const { cart, updateQuantity, removeFromCart, cartTotal, cartCount } = useCart()

    if (cart.length === 0) {
        return (
            <div className="cart-page">
                <div className="container">
                    <div className="empty-cart">
                        <div className="empty-icon">🛒</div>
                        <h2>Your Cart is Empty</h2>
                        <p>Looks like you haven't added any items yet.</p>
                        <Link to="/products" className="btn btn-primary">
                            Browse Products
                        </Link>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="cart-page">
            <div className="container">
                <h1>Shopping Cart</h1>
                <p className="cart-summary">{cartCount} item{cartCount !== 1 ? 's' : ''} in your cart</p>

                <div className="cart-layout">
                    {/* Cart Items */}
                    <div className="cart-items">
                        {cart.map(item => (
                            <div key={item.id} className="cart-item card">
                                <div className="item-image">
                                    {item.images?.[0]?.thumbnail ? (
                                        <img src={item.images[0].thumbnail} alt={item.name} />
                                    ) : (
                                        <div className="item-placeholder">📦</div>
                                    )}
                                </div>
                                <div className="item-details">
                                    <Link to={`/products/${item.slug}`} className="item-name">
                                        {item.name}
                                    </Link>
                                    <div className="item-price">${item.price}</div>
                                </div>
                                <div className="item-quantity">
                                    <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>−</button>
                                    <span>{item.quantity}</span>
                                    <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                                </div>
                                <div className="item-total">
                                    ${(parseFloat(item.price) * item.quantity).toFixed(2)}
                                </div>
                                <button
                                    className="item-remove"
                                    onClick={() => removeFromCart(item.id)}
                                    aria-label="Remove item"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                    </div>

                    {/* Order Summary */}
                    <div className="order-summary card">
                        <h3>Order Summary</h3>
                        <div className="summary-row">
                            <span>Subtotal</span>
                            <span>${cartTotal.toFixed(2)}</span>
                        </div>
                        <div className="summary-row">
                            <span>Shipping</span>
                            <span>Calculated at checkout</span>
                        </div>
                        <div className="summary-row total">
                            <span>Total</span>
                            <span>${cartTotal.toFixed(2)}</span>
                        </div>
                        <Link to="/checkout" className="btn btn-primary btn-lg checkout-btn">
                            Proceed to Checkout
                        </Link>
                        <Link to="/products" className="continue-shopping">
                            Continue Shopping
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
